import { useEffect, useState } from "react";

// 336: PDF do <iframe> přes blob: místo přímé adresy /api/files. Ta nese
// `frame-ancestors 'self'` a Chrome ho kontroluje u VŠECH předků — v náhledu
// Emergentu (aplikace sama v cizím rámečku) nebo s API na jiné doméně pak čtečka
// ukáže jen „Tato stránka je blokována“. Blob žádné hlavičky nemá.
// Když stažení selže, vrátí přímou adresu (dosavadní chování).
export function usePdfBlob(src) {
  const [out, setOut] = useState(null);
  useEffect(() => {
    if (!src) { setOut(null); return undefined; }
    let live = true;
    let made = null;
    setOut(null);
    fetch(src)
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error(String(r.status)))))
      .then((b) => {
        if (!live) return;
        made = URL.createObjectURL(new Blob([b], { type: "application/pdf" }));
        setOut(made);
      })
      .catch(() => { if (live) setOut(src); });
    return () => { live = false; if (made) URL.revokeObjectURL(made); };
  }, [src]);
  return out;
}
